import React, {useEffect} from 'react';
import Carousel from './Carousel';
import bgImage from '../assets/img/carousel-bg.jpg';
import AOS from 'aos';
import 'aos/dist/aos.css';

const CarouselGroup = ({ slidersGroups, isAdmin, refreshSliderGroups }) => {
    useEffect(() => {
      AOS.init();
      window.addEventListener('load', AOS.refresh);
    }, []);  

    return (
      <div className="carousel-group">
        {slidersGroups.map(group => (
          <div key={group.id} data-aos="fade-up" data-aos-offset="150">
            <Carousel
              key={group.id}
              slides={group}
              isAdmin={isAdmin}
              refreshSliderGroups={refreshSliderGroups}
            />
          </div>
        ))}
  
        {isAdmin && (
          <Carousel
            slides={{ sliders: [] }}
            isAdmin={isAdmin}
            refreshSliderGroups={refreshSliderGroups}
          />
        )}
      </div>
    );
  };
  
  export default CarouselGroup;
  